<!--
  @Description cgc 拼团mvp - 完单展示标题
-->
<template>
<div class="group_mvp_process_completed_title">
  <div class="main_title">{{$t('FoodC_Notifications_Congratulations_gTCr' /** Congratulations */)}}</div>
  <div class="sub_title">{{$t('FoodC_Notifications_Congratulations_you_qoKt' /** You earned a reward */)}}</div>
</div>
</template>
<script>
export default {

}
</script>
<style scoped lang="stylus">
.group_mvp_process_completed_title
  .main_title
    height 44px
    // font-family DiDiSansPro-Medium
    font-family Aspira Medium
    font-size 48px
    color #FF8040
    line-height 44px
    font-weight 500
  .sub_title
    margin-top 14px
    width 360px
    height 68px
    // font-family DiDiSansPro-Regular
    font-family 'Aspira Regular'
    font-size 28px
    color #FF8040
    line-height 34px
    font-weight 400
</style>